import template		from "./view-overview.html";
import css			from "./view-overview.css";

import Page			from "../view-page.js";
import HMI			from "./hmi.js";

export default class OverviewView extends Page {  
  static get template() {
    return template;
  }
  
  static get css() {
    return css;
  }
    
  static {
    customElements.define("fulljs-view-overview", OverviewView);
  }

  constructor(...args) {
    super(...args);           
  }

}